export const VerificationTypes = {
  standard: 'B',
  alternate1: 'R',
  alternate2: 'F',
};



// WEBPACK FOOTER //
// ./src/pages/verificationconfiguration/components/VerificationTypes.js